import { Injectable } from '@angular/core';
import { filterNullish, NavigationFacadeInterface } from '@ideapa/app-common';
import { select, Store } from '@ngrx/store';

import { AppNavigationConfig } from '../app-navigation-config';
import * as Actions from './navigation.actions';
import { NavigationPartialState } from './navigation.reducer';
import * as Selectors from './navigation.selectors';

@Injectable({
  providedIn: 'root',
})
export class NavigationFacade implements NavigationFacadeInterface {
  tabs$ = this.store.pipe(select(Selectors.getTabs));

  activeTab$ = this.store.pipe(select(Selectors.getActiveTab), filterNullish());

  constructor(
    private store: Store<NavigationPartialState>,
    private config: AppNavigationConfig
  ) {
    this.init();
  }

  init() {
    this.store.dispatch(Actions.init({ items: this.config.routes }));
  }

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  navigate(path: string) {
    this.store.dispatch(Actions.navigate({ path }));
  }

  navigateToFirstAvailableTab() {
    this.store.dispatch(Actions.navigateToFirstTab());
  }

  showTab(path: string) {
    this.store.dispatch(Actions.showTab({ path }));
  }

  manualCloseTab(path: string) {
    this.store.dispatch(Actions.manualClose({ path }));
  }

  closeTab(path: string) {
    this.store.dispatch(Actions.closeTab({ path }));
  }

  closeEnteAnnoRelatedTabs() {
    this.store.dispatch(Actions.closeEnteAnnoRelatedTabs());
  }

  closeModuloRelatedTabs() {
    this.store.dispatch(Actions.closeModuloRelatedTabs());
  }
}
